import React from 'react';

const NavItem = ({ 
  item, 
  mobile = false, 
  activeSection, 
  setActiveSection,
  setMobileMenuOpen 
}) => {
  const Icon = item.icon;
  const isActive = activeSection === item.id;
  
  const handleClick = () => {
    setActiveSection(item.id);
    if (mobile && setMobileMenuOpen) {
      setMobileMenuOpen(false);
    }
  };

  return (
    <button
      data-nav-id={item.id}
      onClick={handleClick}
      className={`group flex items-center gap-3 px-5 py-3 rounded-full transition-all duration-300 hover:scale-105 ${
        isActive 
          ? 'bg-gray-100 text-gray-900 shadow-sm' 
          : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
      } ${
        mobile ? 'w-full justify-start text-lg hover:scale-[1.02]' : 'text-base relative z-10'
      } font-serif tracking-wide`}
    >
      <Icon 
        size={20} 
        className={`flex-shrink-0 transition-all duration-300 ${
          isActive 
            ? 'scale-110 drop-shadow-sm' 
            : 'group-hover:scale-105'
        }`} 
      />
      <span className={`transition-all duration-300 ${
        isActive ? 'font-medium' : ''
      }`}>
        {item.label}
      </span>
      
      {/* Mobile active indicator */}
      {mobile && isActive && (
        <div className="ml-auto w-2 h-2 bg-gray-400 rounded-full animate-pulse" />
      )}
    </button>
  );
};

export default NavItem;